'use client';

import React, { useState } from 'react';

import { FormSubmissionModal } from '@/components/forms/FormSubmissionModal/FormSubmissionModal';
import {
  serviceEnquiryFields,
  serviceEnquiryDefaultValues,
  serviceEnquirySchema,
} from '@/features/enquiries/forms/serviceEnquirySchema';

import FibroScanPackages from '../FibroScanPackages/FibroScanPackages';
import type { FibroScanPackagesProps } from '../FibroScanPackages/types';

export default function FibroScanPackagesWithModal({
  data,
}: FibroScanPackagesProps): React.ReactElement {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const [enquiryTitle, setEnquiryTitle] = useState<string>(
    'Enquire about this package',
  );

  return (
    <>
      <FibroScanPackages
        data={data}
        onEnquire={(payload) => {
          setEnquiryTitle(
            payload.title
              ? `Enquire about ${payload.title}`
              : 'Enquire about this package',
          );
          setHasBeenOpened(true);
          setEnquiryOpen(true);
        }}
      />
      {hasBeenOpened && (
        <FormSubmissionModal
          open={enquiryOpen}
          onOpenChange={setEnquiryOpen}
          formId="serviceEnquiry"
          schema={serviceEnquirySchema}
          fields={serviceEnquiryFields}
          defaultValues={serviceEnquiryDefaultValues}
          title={enquiryTitle}
          description="Fill in your details and our team will contact you."
          submitLabel="Send enquiry"
          metadata={{
            serviceName: 'FibroScan',
            pageType: 'service',
            source: 'fibroscan-packages',
          }}
        />
      )}
    </>
  );
}
